import React from 'react';
import { InputText } from 'primereact/inputtext';
import { SubSectionHeader } from '../shared/SubSectionHeader';
import { FormField } from '../shared/FormField';
import classes from '../../bidAnalysisTemplate.module.scss';

interface PackSizeOutputSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  formData: any;
  templateType?: string; // 'mas' | 'nc' - to distinguish between MAS and NC templates
  productType?: 'direct' | 'indirect' | null; // 'direct' | 'indirect' - to distinguish between Direct and Indirect products
}

export const PackSizeOutputSection: React.FC<PackSizeOutputSectionProps> = ({
  isExpanded,
  onToggle,
  formData,
  templateType,
  productType,
}) => {
  const isNC = templateType?.toLowerCase() === 'nc';
  const isMASIndirect = templateType?.toLowerCase() === 'mas' && productType === 'indirect';
  const formatNumber = (value: string | number | undefined): string => {
    if (value === null || value === undefined || value === '') return '0.00';
    const num = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(num)) return '0.00';
    return num.toFixed(2);
  };

  return (
    <div className={classes.subSection}>
      <SubSectionHeader
        title="Pack-Size Wise Output Section"
        isExpanded={isExpanded}
        onToggle={onToggle}
      />
      {isExpanded && (
        <div className={classes.subSectionContent}>
          <div className={classes.formGrid3}>
            {/* Hide Target Annual Usage for NC template */}
            {!isNC && (
              <FormField label="Target Annual Usage">
                <InputText value={formatNumber(formData.targetAnnualUsage)} disabled />
              </FormField>
            )}

            <FormField label="Contract Annual Revenue">
              <InputText value={`$${formatNumber(formData.contractAnnualRevenue)}`} disabled />
            </FormField>

            <FormField label="Contract Annual GP">
              <InputText value={`$${formatNumber(formData.contractAnnualGP)}`} disabled />
            </FormField>

            <FormField label="Contract Annual Cost">
              <InputText value={`$${formatNumber(formData.contractAnnualCost)}`} disabled />
            </FormField>

            <FormField label="Government Savings Analysis">
              <InputText value={`$${formatNumber(formData.govSavingsAnalysis)}`} disabled />
            </FormField>

            {/* GSMS Marketing Fee - Only shown for MAS Indirect templates */}
            {isMASIndirect && (
              <FormField label="GSMS Marketing Fee">
                <InputText value={`$${formatNumber(formData.gsmsMarketingFee)}`} disabled />
              </FormField>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

